export default "__VITE_ASSET__DpAnDq3V__"